export default "__VITE_ASSET__bb1c0ee7__"